// extracted by mini-css-extract-plugin
module.exports = {"detail":"water-meter-detail_detail_3Pxvy","listWrap":"water-meter-detail_listWrap_uCgXF"};